import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
function addReactProp(props, name, type, value) {
  if (type === 'string' && typeof value === 'string' && value.trim().length > 0) {
    props[name] = value;
    return;
  }
  if (type === 'boolean' && typeof value === 'boolean' && value) {
    props[name] = value;
    return;
  }
  console.warn("RawHtml: unknown type ".concat(type, " or unsupported value ").concat(value));
}
function addInnerHtml(props, value) {
  if (typeof value === 'string' && value.trim().length > 0) {
    props['dangerouslySetInnerHTML'] = {
      __html: value
    };
    return;
  }
}
function createReactScripElementFromItem(rawKey, codeItem) {
  var props = _defineProperty({}, 'data-rawkey', rawKey);
  addReactProp(props, 'src', 'string', codeItem.data.src);
  addReactProp(props, 'async', 'boolean', codeItem.data.async);
  addReactProp(props, 'defer', 'boolean', codeItem.data.defer);
  addReactProp(props, 'type', 'string', codeItem.data.type);
  addReactProp(props, 'crossorigin', 'string', codeItem.data.crossorigin);
  addReactProp(props, 'integrity', 'string', codeItem.data.integrity);
  addReactProp(props, 'nomodule', 'boolean', codeItem.data.nomodule);
  addReactProp(props, 'referrerpolicy', 'string', codeItem.data.referrerpolicy);
  addInnerHtml(props, codeItem.data.content);
  return React.createElement('script', props);
}
function createReactStyleElementFromItem(rawKey, codeItem) {
  var props = _defineProperty({}, 'data-rawkey', rawKey);
  addInnerHtml(props, codeItem.data.content);
  return React.createElement('style', props);
}
function createReactLinkElementFromItem(rawKey, codeItem) {
  var props = _defineProperty({}, 'data-rawkey', rawKey);
  addReactProp(props, 'href', 'string', codeItem.data.href);
  addReactProp(props, 'rel', 'string', codeItem.data.rel);
  addReactProp(props, 'sizes', 'string', codeItem.data.sizes);
  addReactProp(props, 'type', 'string', codeItem.data.type);
  addReactProp(props, 'media', 'string', codeItem.data.media);
  addReactProp(props, 'as', 'string', codeItem.data.as);
  addReactProp(props, 'crossorigin', 'string', codeItem.data.crossorigin);
  return React.createElement('link', props);
}
function createReactMetaElementFromItem(rawKey, codeItem) {
  var props = _defineProperty({}, 'data-rawkey', rawKey);
  addReactProp(props, 'charset', 'string', codeItem.data.charset);
  addReactProp(props, 'name', 'string', codeItem.data.name);
  addReactProp(props, 'content', 'string', codeItem.data.content);
  addReactProp(props, 'http-equiv', 'string', codeItem.data['http-equiv']);
  addReactProp(props, 'itemprop', 'string', codeItem.data.itemprop);
  return React.createElement('meta', props);
}
var allowedTags = {
  script: createReactScripElementFromItem,
  style: createReactStyleElementFromItem,
  meta: createReactMetaElementFromItem,
  link: createReactLinkElementFromItem
};
export default function codeItemToReactElement(rawKey, codeItem) {
  if (allowedTags[codeItem.tag]) {
    return allowedTags[codeItem.tag](rawKey, codeItem);
  }
  console.warn("RawHtml: unsupported tag ".concat(codeItem.tag));
}